<template>
    <div class="sitemap">
        <div class="row justify-content-center">
            <div class="col-11 col-xl-6">
                <breadcrumbs :dom="crumbsItem" />
                <div class="sitemap_content">
                    <h3>網站地圖</h3>
                    <div class="row">
                        <div class="col-sm-4">
                            <div class="aboutUs">
                                <h4>關於我們</h4>
                                <div class="conitem">
                                    <a :href="homeCompanyUrl" target="_blank">
                                        特力屋手創空間官方網站
                                    </a>
                                    <router-link :to="{ name: 'faq' }">常見問答</router-link>
                                    <router-link :to="{ name: 'policy' }">服務條款</router-link>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-8">
                            <div class="classUl">
                                <h4>課程類別</h4>
                                <div class="row conitem">
                                    <div v-for="(classification, index) in classifications" :key="index" class="col-6 col-lg-4">
                                        <router-link 
                                            :to="{ name: 'products.index', params: { id: classification.TypeID } }">
                                            {{ classification.TypeName }}
                                        </router-link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Breadcrumbs from '@/components/partial/Breadcrumbs'
    import { mapGetters, mapActions } from 'vuex';

    export default {
        components: {
            Breadcrumbs,
        },
        data() {
            return {
                crumbsItem: [{
                        text: '首頁',
                        to: { name: 'home' },
                    },
                    {
                        text: '網站地圖',
                        active: true
                    },
                ],
            }
        },
        created() {
            this.loadClassifications();
            this.loadHomeCompanyUrl();
        },
        computed: {
            ...mapGetters('classifications', [
                'classifications',
            ]),
            ...mapGetters('home', [
                'homeCompanyUrl'
            ]),
        },
        methods: {
            ...mapActions('classifications', [
                'loadClassifications'
            ]),
            ...mapActions('home', [
                'loadHomeCompanyUrl'
            ]),
        },
    }
</script>

